import "./App.css";
import LoadingProgress from "./components/loadingProgress/LoadingProgress";
import MainPage from "./page/mainPage/MainPage";

function App() {
	const blockContextMenu = (e) => {
		e.preventDefault();
	};
	return (
		<div className="app" onContextMenu={blockContextMenu}>
			<LoadingProgress Page={MainPage} />
		</div>
	);
}

export default App;
